import config from '@/config'
import mixpanelUtils from '@/utils/mixpanel.utils'
import eventCategories from '@/constant/eventCategories'
// ============================================
// SOUND EFFECT 2026 - Import paths
// ============================================
import handClapMp3 from '@/assets/audio/sfx-2026/hand-clap.mp3'
import drumMp3 from '@/assets/audio/sfx-2026/drumroll.mp3'
import confettiMp3 from '@/assets/audio/sfx-2026/confetti.mp3'
import spinnerTickMp3 from '@/assets/audio/spinner-wheel-tick.mp3' // to be removed
import spinnerCelebrationMp3 from '@/assets/audio/spinner-wheel-celebration.mp3' // to be removed
import clockTickMp3 from '@/assets/audio/sfx-2026/clock-tick.mp3'
import countdown5Mp3 from '@/assets/audio/sfx-2026/countdown-to-show-question.mp3'
import countdown3Mp3 from '@/assets/audio/sfx-2026/countdown-to-end-question.mp3'
import lobbyToQuestionMp3 from '@/assets/audio/sfx-2026/lobby-to-question.mp3'
import startQuizMp3 from '@/assets/audio/sfx-2026/start-quiz.mp3'
import endNowMp3 from '@/assets/audio/sfx-2026/end-now-button.mp3'
import showAnswerMp3 from '@/assets/audio/show-answer.mp3'
import leaderboardEmptyMp3 from '@/assets/audio/sfx-2026/leaderboard-no-data.mp3'
import leaderboardMiddleMp3 from '@/assets/audio/sfx-2026/middle-leaderboard.mp3'
import leaderboardFinalMp3 from '@/assets/audio/sfx-2026/final-leaderboard.mp3'
import slideNavigationMp3 from '@/assets/audio/sfx-2026/slide-navigation.mp3'
import spinnerTick1Mp3 from '@/assets/audio/sfx-2026/spinner-wheel/spinner-wheel-tick-1.mp3'
import spinnerTick2Mp3 from '@/assets/audio/sfx-2026/spinner-wheel/spinner-wheel-tick-2.mp3'
import spinnerTick3Mp3 from '@/assets/audio/sfx-2026/spinner-wheel/spinner-wheel-tick-3.mp3'
import spinnerTick4Mp3 from '@/assets/audio/sfx-2026/spinner-wheel/spinner-wheel-tick-4.mp3'
import spinnerWheelShowWheelMp3 from '@/assets/audio/sfx-2026/spinner-wheel/show-spinning-wheel.mp3'
import spinnerWheelResultMp3 from '@/assets/audio/sfx-2026/spinner-wheel/spinning-wheel-result.mp3'
import buttonClickMp3 from '@/assets/audio/sfx-2026/button_click.mp3'
import showHideResultIconClickMp3 from '@/assets/audio/sfx-2026/show-hide-result-icon-click.mp3'
import toggleQrCodeMp3 from '@/assets/audio/sfx-2026/toggle-qr-code.mp3'

import dataRevealMp3 from '@/assets/audio/sfx-2026/data-reveal.mp3'
import focusItemMp3 from '@/assets/audio/sfx-2026/focus-item.mp3'
import flipTheBoxMp3 from '@/assets/audio/sfx-2026/flip-the-box.mp3'
import groupSfx from '@/assets/audio/sfx-2026/group.mp3'
import ungroupSfx from '@/assets/audio/sfx-2026/ungroup.mp3'
import { SLIDE_TYPES_MAP } from '@/constant/slideTypes'
import QuizStatuses from '@/constant/QuizStatuses'
import playingQuizMusic from '@/assets/audio/quiz-bg-music-v2.mp3'

// Vuex store & feature toggle strings defined as constants to avoid duplication
const CAN_SEPARATE_VOLUME_CONTROL = 'featureToggles/canSeparateVolumeControl'
const CAN_USE_NEW_SFX_SETTINGS = 'featureToggles/canUseNewSfxSettings'
const PLAY_SOUND_EFFECT_ACTION = 'audio/playSoundEffectAction'
const PLAY_MUSIC_ACTION = 'audio/playMusicAction'
const STOP_MUSIC_ACTION = 'audio/stopMusicAction'
// AHA-43274 / AHA-47085: dispatched from audioPlugin's watch on the two stand-down edges — see the
// actions. They are a pair; a frame that pauses on the way down must resume on the way back up.
const STAND_DOWN_STOP_AUDIO_ACTION = 'audio/stopAudioOnPptStandDownAction'
const STAND_UP_RESUME_AUDIO_ACTION = 'audio/resumeAudioOnPptStandUpAction'
// AHA-47085: the same pair for the EDITOR, dispatched from the second watch in audioPlugin.
const EDIT_GATE_STOP_AUDIO_ACTION = 'audio/stopAudioOnPptEditSlideNotSelectedAction'
const EDIT_GATE_RESUME_AUDIO_ACTION = 'audio/resumeAudioOnPptEditSlideSelectedAction'
// The same action as PLAY_MUSIC_ACTION above, addressed from INSIDE the module — the namespaced form
// is for store.dispatch out of audioPlugin, and a local dispatch must not carry the prefix.
const PLAY_MUSIC_LOCAL_ACTION = 'playMusicAction'
const CAN_USE_EDIT_SLIDE_AUDIO_GATE = 'featureToggles/canUsePptEditSlideAudioGate'

// Music sources

// ============================================
// SOUND EFFECT SOURCES - Only paths, lazy load
// ============================================
const SOUND_EFFECT_SOURCES = {
  HAND_CLAP: handClapMp3,
  DRUM: drumMp3,
  CONFETTI: confettiMp3,
  SPINNER_TICK: spinnerTickMp3,
  SHOW_QUESTION: spinnerTickMp3, // TODO: replace the actual show_question sound
  SPINNER_CELEBRATION: spinnerCelebrationMp3,
  LOBBY_TO_QUESTION: lobbyToQuestionMp3,
  COUNTDOWN_TO_SHOW_QUESTION: countdown5Mp3,
  COUNTDOWN_TO_END_QUESTION: countdown3Mp3,
  CLOCK_TICK: clockTickMp3,
  START_QUIZ: startQuizMp3,
  END_NOW: endNowMp3,
  REVEAL_ANSWER: showAnswerMp3,
  SLIDE_NAVIGATION: slideNavigationMp3,
  LEADERBOARD_EMPTY: leaderboardEmptyMp3,
  LEADERBOARD_MIDDLE: leaderboardMiddleMp3,
  LEADERBOARD_FINAL: leaderboardFinalMp3,
  SPINNER_TICK_1: spinnerTick1Mp3,
  SPINNER_TICK_2: spinnerTick2Mp3,
  SPINNER_TICK_3: spinnerTick3Mp3,
  SPINNER_TICK_4: spinnerTick4Mp3,
  SPINNER_WHEEL_SHOW: spinnerWheelShowWheelMp3,
  SPINNER_WHEEL_RESULT: spinnerWheelResultMp3,
  BUTTON_CLICK: buttonClickMp3,
  SHOW_HIDE_RESULT_CLICK: showHideResultIconClickMp3,
  TOGGLE_QR_CODE: toggleQrCodeMp3,
  DATA_REVEAL: dataRevealMp3,
  FOCUS_ITEM: focusItemMp3,
  FLIP_THE_BOX: flipTheBoxMp3,
  GROUP: groupSfx,
  UNGROUP: ungroupSfx,
}

const MUSIC_SOURCES = {
  DEFAULT_QUIZ_LOBBY_MUSIC: `${config.cloudfrontPublic}/BGM/new-lobby-music-v2.mp3`,
}

// ============================================
// CACHE - Store created Audio instances
// ============================================
const soundEffectCache = {}
const musicCache = {}

// ============================================
// FACTORY FUNCTIONS - Lazy load with cache
// ============================================

/**
 * Get sound effect by key - lazy load and cache
 * @param {string} key - Sound effect key (e.g., 'CONFETTI', 'HAND_CLAP')
 * @returns {Audio|null} - Audio instance or null if key not found
 */
export const getSoundEffect = (key) => {
  if (!soundEffectCache[key]) {
    const src = SOUND_EFFECT_SOURCES[key]
    if (!src) return null
    soundEffectCache[key] = new Audio(src)
  }
  return soundEffectCache[key]
}

/**
 * Get music by key - lazy load and cache
 * @param {string} key - Music key (e.g., 'LOBBY', 'PLAYING_QUIZ')
 * @returns {Audio|null} - Audio instance or null if key not found
 */
export const getMusic = (key) => {
  if (!musicCache[key]) {
    const src = MUSIC_SOURCES[key]
    if (!src) return null
    musicCache[key] = new Audio(src)
  }
  return musicCache[key]
}

/**
 * Create dynamic music from URL (for background music, slide audio)
 * @param {string} url - Music URL
 * @param {Object} options - Options (loop, preload)
 * @returns {Audio} - New Audio instance
 */
export const createDynamicMusic = (url, options = {}) => {
  const audio = new Audio(url)
  if (options.loop) audio.loop = true
  if (options.preload) audio.preload = options.preload
  return audio
}

// Export keys for type safety
export const SOUND_EFFECT_KEYS = Object.keys(SOUND_EFFECT_SOURCES)
export const MUSIC_KEYS = Object.keys(MUSIC_SOURCES)

// ============================================
// HELPER FUNCTIONS
// ============================================

const playSound = (sound) => {
  sound.play().catch(() => { })
}

const stopSound = (sound) => {
  sound.pause()
  // eslint-disable-next-line no-param-reassign
  sound.currentTime = 0
}

// AHA-47085: autoplay-policy recovery.
//
// An Office add-in is an iframe with its own Document, and the autoplay policy grants unmuted
// playback per Document. Clicking a slide in PowerPoint is a gesture in the HOST, so the add-in
// frame never earns activation from it however much the user clicks around the deck — every
// play() there rejects with NotAllowedError until something is clicked INSIDE the frame.
//
// navigator.userActivation has no change event, so there is nothing to await. The gesture events
// below are the signal: a listener that fires during one is BY DEFINITION running inside a user
// activation, which is exactly when play() is permitted. Retrying there rather than on a timer is
// what makes this deterministic instead of a poll that races the policy.
const USER_GESTURE_EVENTS = ['pointerdown', 'keydown', 'touchend']

// Deliberately NOT keyed off navigator.userActivation. It is Chromium-only, and more to the point it
// is a level with no change event — reading it tells you where you have been, never when to act.
// The events are the signal; the flag would only ever be a thing to poll.
//
// At most one pending retry. Re-arming replaces the callback rather than stacking a second listener:
// the newest request is the one that reflects what the presentation is currently on, and a stack
// would fire every stale one on the same gesture.
let pendingAutoplayRetry = null

const disarmAutoplayRetry = () => {
  if (!pendingAutoplayRetry) return
  USER_GESTURE_EVENTS.forEach((type) => {
    window.removeEventListener(type, pendingAutoplayRetry.fire, true)
  })
  pendingAutoplayRetry = null
}

const armAutoplayRetry = (onActivated) => {
  if (pendingAutoplayRetry) {
    pendingAutoplayRetry.onActivated = onActivated
    return
  }
  const entry = { onActivated }
  entry.fire = () => {
    const { onActivated: run } = entry
    // Disarmed BEFORE running, so a retry that rejects again can re-arm cleanly for the next
    // gesture instead of being swallowed by the guard at the top of this function.
    disarmAutoplayRetry()
    run()
  }
  pendingAutoplayRetry = entry
  // Capture phase, so a handler that stops propagation somewhere in the app cannot starve this.
  USER_GESTURE_EVENTS.forEach((type) => {
    window.addEventListener(type, entry.fire, true)
  })
}

// AHA-47085: what to do with a rejected music play(). Lives here rather than inline in
// playMusicAction because that action is already over the cognitive-complexity budget.
const handleMusicPlayRejection = (err, state, rootGetters, dispatch) => {
  // OUTSIDE the flag check below, and it has to stay there. This warning predates AHA-47085 — it is
  // the whole of what the original inline catch did, and it is what surfaced the NotAllowedError in
  // the first place. Moving it under the flag would make switching the flag off remove diagnostics
  // that staging already has, which is not what a kill switch is for.
  // eslint-disable-next-line no-console
  console.warn('[audio.module] playMusicAction play() rejected:', err)
  // Everything past here is new behaviour, so it answers to the flag: with AHA-47085 off, a rejected
  // play() logs and stops exactly as it does on staging, with no listener left on window.
  if (!rootGetters[CAN_USE_EDIT_SLIDE_AUDIO_GATE]) return
  // Only the autoplay policy is recoverable this way. Every other rejection (a dead src, a decode
  // failure, an element torn down mid-call) would fail identically on the next gesture, and
  // retrying it would only move the same error to a more confusing moment.
  if (err?.name !== 'NotAllowedError') return
  armAutoplayRetry(() => {
    // Re-dispatched rather than replayed on the captured element, so EVERY guard in playMusicAction
    // is re-evaluated against the state at gesture time. By then the frame may have been stood down,
    // the music stopped (currentMusicSrc null), or the deck moved to a slide that wants a different
    // track — and a blocked play must not resurrect any of those.
    if (!state.currentMusicSrc) return
    dispatch('playMusicAction', state.currentMusicSrc)
  })
}

const shouldSilencePresentationAudio = (slide) => {
  if (!slide || !slide.audioLink?.url) return false
  if (slide.type === SLIDE_TYPES_MAP.PICK_ANSWER) {
    return slide.quizStatus === QuizStatuses.QUESTION_SCREEN
  }
  return true
}

// ============================================
// STATE
// ============================================
const _state = {
  activeSounds: [], // Active sound effects
  musicHTMLAudioElement: null, // the <audio> element for background music
  slideHTMLAudioElement: null, // the <audio> element for the ACTIVE slide's own audio (SlideTitleAudioPlayer)
  currentMusicSrc: null, // Reactive source for music
  presentationVolume: parseFloat(localStorage.getItem('aha_presentation_volume') || '1'),
}

// ============================================
// GETTERS
// ============================================
const _getters = {
  isEnableSoundEffects: (state, getters, rootState) => {
    if (!rootState.presentation?.isEnableQuizMusic) return false
    return rootState.presentation?.isEnableSoundEffects ?? true
  },
  isEnableSoundEffectsForAudience: (state, getters, rootState) => {
    return rootState.presentation?.isEnableSoundEffectsForAudience ?? false
  },
  isEnableMusic: (state, getters, rootState) => {
    return rootState.presentation?.isEnableMusic ?? true
  },
  musicSrc: (state) => {
    return state.currentMusicSrc
  },
}

// ============================================
// MUTATIONS
// ============================================
const mutations = {
  ADD_ACTIVE_SOUND(state, sound) {
    if (!state.activeSounds.includes(sound)) {
      state.activeSounds.push(sound)
    }
  },
  REMOVE_ACTIVE_SOUND(state, sound) {
    const index = state.activeSounds.indexOf(sound)
    if (index > -1) {
      state.activeSounds.splice(index, 1)
    }
  },
  CLEAR_ALL_ACTIVE_SOUNDS(state) {
    // eslint-disable-next-line no-param-reassign
    state.activeSounds = []
  },
  SET_ACTIVE_MUSIC(state, music) {
    // eslint-disable-next-line no-param-reassign
    state.currentMusicSrc = music
    if (!state.musicHTMLAudioElement) return
    state.musicHTMLAudioElement.src = music
  },
  SET_AUDIO_ELEMENT(state, audioElement) {
    // eslint-disable-next-line no-param-reassign
    state.musicHTMLAudioElement = audioElement
  },
  SET_SLIDE_AUDIO_ELEMENT(state, audioElement) {
    // eslint-disable-next-line no-param-reassign
    state.slideHTMLAudioElement = audioElement
  },
  SET_CURRENT_MUSIC_SRC(state, src) {
    // eslint-disable-next-line no-param-reassign
    state.currentMusicSrc = src
  },
  SET_PRESENTATION_VOLUME(state, volume) {
    // eslint-disable-next-line no-param-reassign
    state.presentationVolume = volume
    localStorage.setItem('aha_presentation_volume', volume.toString())
  },
}

// ============================================
// ACTIONS
// ============================================
const actions = {
  toggleMusicAndSfxAction({
    dispatch, getters,
  }) {
    const newValue = !(getters.isEnableSoundEffects || getters.isEnableMusic)

    dispatch('toggleMusicAction', newValue)
    dispatch('toggleSoundEffectAction', newValue)
  },

  setPresentationVolumeAction({ commit, state }, volume) {
    commit('SET_PRESENTATION_VOLUME', volume)
    state.activeSounds.forEach((sound) => {
      // eslint-disable-next-line no-param-reassign
      sound.volume = volume
    })
    if (state.musicHTMLAudioElement) {
      state.musicHTMLAudioElement.volume = volume
    }
  },

  // ---- Sound Effects ----
  // Toggle: on = resume, off = pause
  toggleSoundEffectAction({
    state, dispatch, rootState, getters,
  }, overrideValue) {
    const newValue = overrideValue !== undefined ? overrideValue : !getters.isEnableSoundEffects

    // Mute/unmute active sounds (keep playing to stay in sync with animation)
    state.activeSounds.forEach((sound) => {
      // eslint-disable-next-line no-param-reassign
      sound.muted = !newValue
    })

    // Persist to API (update presentation)
    const presentationId = rootState.presentation?.id
    if (presentationId) {
      dispatch('updatePresentationByIdAction', {
        id: presentationId,
        payload: {
          isEnableSoundEffects: newValue,
          isEnableQuizMusic: newValue, // set the legacy value as well
        },
      }, { root: true })
    }
    mixpanelUtils.track(
      'Sound Effects > Toggle',
      {
        event_category: eventCategories.PRESENTATION_EDITOR,
        event_label: newValue,
        presentation_id: rootState.presentation?.id,
      },
    )
  },

  toggleSoundEffectForAudienceAction({
    dispatch, rootState, getters,
  }, overrideValue) {
    const newValue = overrideValue !== undefined ? overrideValue : !getters.isEnableSoundEffectsForAudience

    // Persist to API (update presentation)
    const presentationId = rootState.presentation?.id
    if (presentationId) {
      dispatch('updatePresentationByIdAction', {
        id: presentationId,
        payload: {
          isEnableSoundEffectsForAudience: newValue,
        },
      }, { root: true })
    }
    mixpanelUtils.track(
      'Audience Sound Effects > Toggle',
      {
        event_category: eventCategories.PRESENTATION_EDITOR,
        event_label: newValue,
        presentation_id: presentationId,
      },
    )
  },

  /**
   * Play sound effect by key (lazy load)
   * @param {string} key - Sound effect key (e.g., 'CONFETTI')
   * @returns {Audio|null} - Audio instance or null
   */
  async playSoundEffectAction({
    state, getters, commit, rootGetters, rootState,
  }, key) {
    if (!rootGetters[CAN_USE_NEW_SFX_SETTINGS]) return null
    // If users already turned off the legacy Quiz Sound Effect (on General Quiz settings > Sound effects)
    // don't play the new SFX for them
    if (!rootState?.presentation?.isEnableQuizMusic) return null
    if (!rootGetters.isPresenting) return null
    if (rootGetters.isBackstage) return null
    // AHA-43274: a PowerPoint add-in frame that is not the one the slideshow is on. Every frame in
    // the deck is a live presenter instance, so without this each of them plays the quiz's sound
    // effects over the top of the frame that is actually presenting.
    if (rootGetters.isPptFrameStoodDown) return null
    // AHA-47085: the same suppression for the PowerPoint EDITOR, where the frame is equally live but
    // the user has a DIFFERENT frame's slide selected. Separate term rather than a widened one: the
    // two verdicts are mutually exclusive by construction (one requires view 'read', the other
    // 'edit'), carry different flags, and fail opposite ways on an unknown.
    if (rootGetters.isPptEditSlideNotSelected) return null
    const sound = getSoundEffect(key)
    if (!sound) return null

    // Skip if already active (playing or muted-playing)
    if (state.activeSounds.includes(sound)) return sound

    commit('ADD_ACTIVE_SOUND', sound)
    // Auto-remove from activeSounds when playback ends
    sound.onended = () => {
      commit('REMOVE_ACTIVE_SOUND', sound)
    }
    stopSound(sound) // Reset to start
    sound.muted = !getters.isEnableSoundEffects
    if (rootGetters[CAN_SEPARATE_VOLUME_CONTROL]) {
      sound.volume = state.presentationVolume
    }
    playSound(sound) // Always play to keep time in sync
    return sound
  },

  /**
   * Stop sound effect by key
   * @param {string} key - Sound effect key
   */
  stopSoundEffectAction({ commit }, key) {
    const sound = getSoundEffect(key)
    if (!sound) return

    stopSound(sound)
    commit('REMOVE_ACTIVE_SOUND', sound)
  },

  /**
   * Play sound effect instance directly (for dynamic sounds)
   * @param {Audio} sound - Audio instance
   */
  playSoundInstanceAction({
    state, getters, commit, rootGetters,
  }, sound) {
    if (!sound) return
    if (rootGetters.isBackstage) return
    if (rootGetters.isPptFrameStoodDown) return // AHA-43274 — see playSoundEffectAction
    if (rootGetters.isPptEditSlideNotSelected) return // AHA-47085 — see playSoundEffectAction
    if (state.activeSounds.includes(sound)) return

    commit('ADD_ACTIVE_SOUND', sound)
    sound.onended = () => {
      commit('REMOVE_ACTIVE_SOUND', sound)
    }
    stopSound(sound)
    // eslint-disable-next-line no-param-reassign
    sound.muted = !getters.isEnableSoundEffects
    if (rootGetters[CAN_SEPARATE_VOLUME_CONTROL]) {
      sound.volume = state.presentationVolume
    }
    playSound(sound)
  },

  /**
   * Stop sound effect instance directly
   * @param {Audio} sound - Audio instance
   */
  stopSoundInstanceAction({ commit }, sound) {
    if (!sound) return
    stopSound(sound)
    commit('REMOVE_ACTIVE_SOUND', sound)
  },

  /**
   * Play sound effect with interrupt+restart behavior (for rapid-fire sounds like spinner tick)
   * Unlike playSoundEffectAction, this does NOT track in activeSounds (zero Vuex mutations)
   * and always restarts the sound from the beginning with throttle to limit call frequency
   * @param {Object} payload - { key: string, throttleMs?: number }
   */
  playRapidSoundEffectAction({ getters, rootGetters, state }, { key, throttleMs = 45 }) {
    if (!rootGetters.isPresenting) return
    if (rootGetters.isBackstage) return
    if (rootGetters.isPptFrameStoodDown) return // AHA-43274 — see playSoundEffectAction
    if (rootGetters.isPptEditSlideNotSelected) return // AHA-47085 — see playSoundEffectAction
    if (!getters.isEnableSoundEffects) return
    const sound = getSoundEffect(key)
    if (!sound) return
    const now = Date.now()
    if (now - (sound._lastPlay || 0) < throttleMs) return
    sound._lastPlay = now
    stopSound(sound)
    if (rootGetters[CAN_SEPARATE_VOLUME_CONTROL]) {
      sound.volume = state.presentationVolume
    }
    playSound(sound)
  },

  registerSoundAction({ commit }, sound) {
    commit('ADD_ACTIVE_SOUND', sound)
  },

  unregisterSoundAction({ commit }, sound) {
    stopSound(sound)
    commit('REMOVE_ACTIVE_SOUND', sound)
  },

  // ---- Music ----
  // Toggle: on = unmute, off = mute (keep playing to maintain time position)
  toggleMusicAction({
    state, dispatch, rootState, getters,
  }, overrideValue) {
    const newValue = overrideValue !== undefined ? overrideValue : !getters.isEnableMusic
    // Mute/unmute active musics (keep playing to stay in sync)
    if (state.musicHTMLAudioElement) {
      if (newValue) {
        state.musicHTMLAudioElement.play()?.catch((err) => {
          // eslint-disable-next-line no-console
          console.warn('[audio.module] toggleMusicAction play() rejected:', err)
        })
      } else {
        state.musicHTMLAudioElement.pause()
      }
    }

    // Persist to API (update presentation)
    const presentationId = rootState.presentation?.id
    if (presentationId) {
      dispatch('updatePresentationByIdAction', {
        id: presentationId,
        payload: {
          isEnableMusic: newValue,
          isEnableQuizMusic: newValue,
        },
      }, { root: true })
    }

    mixpanelUtils.track(
      'Music > Toggle',
      {
        event_category: eventCategories.PRESENTATION_EDITOR,
        event_label: newValue,
        presentation_id: presentationId,
      },
    )
  },

  initAudioElementForMusicAction({
    commit, rootState, rootGetters, state,
  }, audioElement) {
    if (!audioElement) return
    // A re-created MusicToggle brings a new <audio autoplay>; the old, now-detached
    // one keeps looping. Hard-stop it here (load() aborts any pending play() so there's
    // no pause/play race) before it becomes an untracked orphan that stopMusic can't reach.
    const prevElement = state.musicHTMLAudioElement
    if (prevElement && prevElement !== audioElement) {
      prevElement.pause()
      prevElement.removeAttribute('src')
      prevElement.load()
    }
    const canSeparateVolume = rootGetters[CAN_SEPARATE_VOLUME_CONTROL]
    let initMusicSrc = null
    // Plugin quizzes get the default lobby music too (isQuizSlide guards a null slide).
    const isQuizSlide = rootGetters['slideModule/isQuizSlide'](rootState.slideActive)
    const defaultLobbyMusic = isQuizSlide ? MUSIC_SOURCES.DEFAULT_QUIZ_LOBBY_MUSIC : null
    if (canSeparateVolume) {
      initMusicSrc = rootState.presentation?.audioLink?.url || defaultLobbyMusic
    } else {
      initMusicSrc = isQuizSlide
        ? rootState.presentation.audioLink?.url || MUSIC_SOURCES.DEFAULT_QUIZ_LOBBY_MUSIC
        : rootState.slideActive.audioLink?.url || rootState.presentation.audioLink?.url
    }
    commit('SET_CURRENT_MUSIC_SRC', initMusicSrc)
    commit('SET_AUDIO_ELEMENT', audioElement)
    if (canSeparateVolume && audioElement) {
      audioElement.volume = state.presentationVolume
    }
  },

  // ---- Stop All (when exiting presenting mode) ----
  /**
   * Stop all active sounds and musics
   * Called when user exits presenting mode
   */
  stopAllAction({ state, commit, dispatch }) {
    // Stop all sound effects
    state.activeSounds.forEach(stopSound)
    commit('CLEAR_ALL_ACTIVE_SOUNDS')

    dispatch('stopMusicAction')
  },

  stopAllSoundEffectsAction({ state, commit }) {
    state.activeSounds.forEach(stopSound)
    commit('CLEAR_ALL_ACTIVE_SOUNDS')
  },

  /**
   * AHA-43274: silence a frame the tag poll has just stood down.
   *
   * Every isPptFrameStoodDown test in this module is an ENTRY guard — it stops a stood-down frame
   * from STARTING audio, and by construction can do nothing about audio that was already playing
   * when the frame lost the show. That is the case a frame hits on the way out, every time: the
   * presenter navigates off this frame's slide mid-quiz, its lobby music or countdown SFX is in
   * flight, the poll stands the frame down, and from then on every play*() call correctly returns
   * early while the sound that is actually audible keeps going. Only a reaction to the EDGE can
   * stop that one — the store.watch in audioPlugin below — and this is what it dispatches.
   *
   * Gated on the getter rather than on the flag directly, so it carries all four of its terms: flag
   * off, not an add-in, or a frame back in the editor and this is a no-op, exactly like the guards
   * it completes.
   *
   * PLUS the AHA-47085 flag, which the getter does not carry. isPptFrameStoodDown answers to
   * AHA-43274, and that flag governs a shipped feature — the quiz auto-stop and the ENTRY guards
   * that stop a stood-down frame from starting audio. Stopping audio already in flight is new work
   * on top of it, so it gets its own switch: with AHA-47085 off, the stand-down edge dispatches this
   * and nothing happens, which is precisely the pre-AHA-47085 behaviour. Without the extra term the
   * only way to turn this off would be to disable the quiz auto-stop with it.
   *
   * Music is PAUSED rather than torn down the way stopMusicAction does. Pausing is enough to make
   * the frame silent, and it leaves src and position intact, so a frame that regains the show has
   * something to resume rather than a cleared element to reload from zero. Sound effects are reset
   * and dropped from activeSounds, because they are one-shots — there is nothing to resume, and a
   * finished sound left in the list would block its own next play (playSoundEffectAction returns
   * early for a sound already tracked there).
   */
  stopAudioOnPptStandDownAction({ state, commit, rootGetters }) {
    if (!rootGetters[CAN_USE_EDIT_SLIDE_AUDIO_GATE]) return
    if (!rootGetters.isPptFrameStoodDown) return
    state.activeSounds.forEach(stopSound)
    commit('CLEAR_ALL_ACTIVE_SOUNDS')
    state.musicHTMLAudioElement?.pause()
  },

  /**
   * AHA-47085: the other half of the pause above — this frame has just taken the show back.
   *
   * Required, not a nicety. Nothing else in the add-in restarts the music: a frame arriving back on
   * its slide runs startActiveSlidePPT, whose lobby stamp is what the editor relies on to re-trigger
   * playback (QuizSlideContent watches quizStatus and dispatches QUIZ/LOBBY_SCREEN on the change),
   * but by then resetLocalQuizToLobbyOnStandDown has ALREADY stamped LOBBY_SCREEN on the way out —
   * so the arrival writes the value the slide already holds, the watcher never fires, and the
   * dispatch never happens. MusicToggle's <audio autoplay> cannot cover it either: pausing an
   * element clears its can-autoplay flag, so re-enabling the attribute does not restart it. Without
   * this the first stand-down leaves the frame silent for the rest of the show.
   *
   * Delegates to playMusicAction rather than calling play() here, so every condition that decides
   * whether this frame may make a sound stays in ONE place — sharing, backstage, a muted
   * presentation, a quiz question screen whose slide audio owns the channel, and the stand-down
   * term itself, which by definition has just gone false. currentMusicSrc is the src the BGM
   * channel last held; null means nothing was playing to resume (stopMusicAction clears it), which
   * is why this is keyed off it rather than off the element's paused state.
   *
   * Carries the AHA-47085 flag for the same reason as the pause it undoes, and it MUST be the same
   * flag: a resume that could run while the pause was switched off would be free to start music in
   * a frame nothing had ever silenced. The two are only safe as a pair.
   */
  resumeAudioOnPptStandUpAction({ state, rootGetters, dispatch }) {
    if (!rootGetters[CAN_USE_EDIT_SLIDE_AUDIO_GATE]) return
    if (!state.currentMusicSrc) return
    dispatch('playMusicAction', state.currentMusicSrc)
  },

  /**
   * AHA-47085: the EDITOR's version of the stand-down pause above.
   *
   * The two cannot share one action even though the bodies match. stopAudioOnPptStandDownAction
   * guards on isPptFrameStoodDown, which requires addinPPTActiveView === 'read' and so is false by
   * construction everywhere this one applies — dispatching it from the editor would return early
   * every time. Duplicating three lines is the cost of each action carrying its own verdict; folding
   * the two verdicts into one term instead would have meant editing the guard on every existing
   * call site, and the flag-off path has to stay byte-for-byte what it is today.
   *
   * The BGM channel is what makes this necessary. It is a different element from the slide-title
   * audio the component-level gate pauses (SlideTitleAudioPlayer owns its own `new Audio()`, needs
   * BOTH audioLink and audioName, and is simply absent on a deck that has neither), whereas this one
   * lives in MusicToggle, needs only audioLink.url, and falls back to a hardcoded lobby track. A
   * frame with no slide-title audio at all still plays this, which is why the gate looked inert.
   */
  stopAudioOnPptEditSlideNotSelectedAction({ state, commit, rootGetters }) {
    if (!rootGetters.isPptEditSlideNotSelected) return
    state.activeSounds.forEach(stopSound)
    commit('CLEAR_ALL_ACTIVE_SOUNDS')
    state.musicHTMLAudioElement?.pause()
  },

  /**
   * AHA-47085: the frame's slide has just become the selected one again.
   *
   * Delegates to the stand-up action rather than repeating it: that one is view-agnostic — it only
   * asks what the BGM channel last held and re-dispatches through playMusicAction, where every
   * guard (including the edit term, which by definition has just gone false) is re-evaluated.
   *
   * The addinPPTActiveView check is this action's own, and it is load-bearing: the edit verdict also
   * goes false when a SLIDESHOW starts and the view flips to 'read'. That edge must not resume
   * anything, because the read-view verdict that owns the question is a tag poll that has not
   * necessarily landed yet — a background frame would blurt out a bar of music before standing down.
   */
  resumeAudioOnPptEditSlideSelectedAction({ rootState, dispatch }) {
    if (rootState.addinPPTActiveView !== 'edit') return
    dispatch('resumeAudioOnPptStandUpAction')
  },

  /**
   * AHA-47085: turn the silent autoplay attempt at mount into one we can see fail.
   *
   * MusicToggle starts the BGM through the <audio autoplay> ATTRIBUTE, and that is the whole problem
   * on a cold load: the attribute path has no promise and no catch, so when the autoplay policy
   * refuses it — which it does in an add-in frame, an iframe with its own Document that has never
   * been clicked — it fails with no error, no event and no log. Nothing in the app learns that the
   * frame is silent, so handleMusicPlayRejection never runs and no retry is ever armed.
   *
   * The only code path that calls play() explicitly is the stand-up/edit resume, which is why
   * clicking to another frame and back is currently the one way to get sound: the round trip
   * produces a real play() AND the click grants the user activation that lets it succeed.
   *
   * This makes the same call at mount. If autoplay was going to work, play() on an already-playing
   * element resolves and this is a no-op. If it was blocked, the rejection reaches
   * handleMusicPlayRejection, which arms the gesture retry — so the FIRST click anywhere inside the
   * frame starts the music, instead of requiring the click-away-and-back dance.
   *
   * It cannot make sound appear before a gesture: no code can overrule the autoplay policy. What it
   * changes is which gesture counts, from one specific sequence to any of them.
   *
   * Scoped to add-in frames and carried by the AHA-47085 flag, so the web editor's mount path is
   * byte-for-byte what it is today and switching the flag off restores this one too.
   */
  ensureMusicAutoplayAction({
    state, rootState, rootGetters, dispatch,
  }) {
    if (!rootState.isEnableAddinPowerpoint) return
    if (!rootGetters[CAN_USE_EDIT_SLIDE_AUDIO_GATE]) return
    // Set by initAudioElementForMusicAction, which the caller runs immediately before this. Null
    // means the deck has no presentation music and no lobby fallback — nothing was ever going to
    // autoplay, so there is nothing to recover.
    if (!state.currentMusicSrc) return
    if (!state.musicHTMLAudioElement) return
    dispatch(PLAY_MUSIC_LOCAL_ACTION, state.currentMusicSrc)
  },

  setActiveMusicAction({ commit }, music) {
    commit('SET_ACTIVE_MUSIC', music)
  },
  stopMusicAction({ state, commit }) {
    if (!state.musicHTMLAudioElement) return
    state.musicHTMLAudioElement.src = ''
    state.musicHTMLAudioElement.removeAttribute('src')
    commit('SET_CURRENT_MUSIC_SRC', null)
    state.musicHTMLAudioElement.pause()
  },
  playMusicAction({
    state, rootState, commit, rootGetters, dispatch,
  }, musicSrc) {
    if (!musicSrc) return
    if (rootState.sharePresentation) return
    if (rootGetters.isBackstage) return
    if (rootGetters.isPptFrameStoodDown) return // AHA-43274 — see playSoundEffectAction
    if (rootGetters.isPptEditSlideNotSelected) return // AHA-47085 — see playSoundEffectAction
    if (rootState?.presentation?.isEnableQuizMusic === false) return

    if (state.currentMusicSrc !== musicSrc) {
      if (state.musicHTMLAudioElement) {
        state.musicHTMLAudioElement.src = musicSrc
      }
      commit('SET_CURRENT_MUSIC_SRC', musicSrc)
    }
    if (rootState.presentation?.isEnableMusic) {
      if (rootGetters[CAN_SEPARATE_VOLUME_CONTROL]) {
        if (state.musicHTMLAudioElement) {
          state.musicHTMLAudioElement.volume = state.presentationVolume
        }
        if (shouldSilencePresentationAudio(rootState.slideActive)) {
          return
        }
      }
      state.musicHTMLAudioElement?.play()?.catch(
        (err) => handleMusicPlayRejection(err, state, rootGetters, dispatch),
      )
    }
  },
  preloadMusicAndSoundEffectAction({ rootState }) {
    const slideMusicUrl = rootState.slideActive?.audioLink?.url
    const presentationMusicUrl = rootState.presentation?.audioLink?.url

    const urlsToPreload = [slideMusicUrl, presentationMusicUrl].filter(Boolean)
    const uniqueUrls = [...new Set(urlsToPreload)]

    uniqueUrls.forEach((url) => {
      createDynamicMusic(url, { preload: 'auto' })
    })

    // Preload all sound effects to avoid delay on first play
    SOUND_EFFECT_KEYS.forEach((key) => {
      const sound = getSoundEffect(key)
      if (sound && sound.preload !== 'auto') {
        sound.preload = 'auto'
      }
    })
  },
}

const ACTION_HANDLERS = {
  'PRESENTATION/IS_LOADED': (store) => {
    store.dispatch('audio/preloadMusicAndSoundEffectAction')
  },
  'PRESENTATION/STOP_PRESENTING': (store) => {
    store.dispatch('audio/stopAllAction')
  },
  'PRESENTATION/TOGGLE_QR_CODE': (store) => {
    store.dispatch(PLAY_SOUND_EFFECT_ACTION, 'TOGGLE_QR_CODE')
  },
  'QUIZ/LOBBY_SCREEN': (store) => {
    const lobbyMusic = store.state?.presentation?.audioLink?.url || MUSIC_SOURCES.DEFAULT_QUIZ_LOBBY_MUSIC
    store.dispatch(PLAY_MUSIC_ACTION, lobbyMusic)
  },
  'QUIZ/START_QUIZ': (store) => {
    store.dispatch(PLAY_SOUND_EFFECT_ACTION, 'START_QUIZ')
  },
  'QUIZ/SHOW_QUESTION_NUMBER': (store) => {
    store.dispatch(STOP_MUSIC_ACTION)
  },
  'QUIZ/COUNTDOWN_TO_SHOW_QUESTION': (store) => {
    store.dispatch(PLAY_SOUND_EFFECT_ACTION, 'LOBBY_TO_QUESTION')
    setTimeout(() => {
      store.dispatch(PLAY_SOUND_EFFECT_ACTION, 'COUNTDOWN_TO_SHOW_QUESTION')
    }, 200)
  },
  'QUIZ/SHOW_QUESTION': (store) => {
    store.dispatch(PLAY_SOUND_EFFECT_ACTION, 'LOBBY_TO_QUESTION')
    const canSeparateVolume = store.getters[CAN_SEPARATE_VOLUME_CONTROL]
    const slideAudioUrl = store.state?.slideActive?.audioLink?.url

    if (canSeparateVolume) {
      // Separate Volume Control ON:
      // - If slide has audio, SlideTitleAudioPlayer.vue plays it. BGM channel must be silent/stopped.
      // - If slide does not have audio, play presentation-level BGM (or fallback to default quiz BGM)
      if (slideAudioUrl) {
        store.dispatch(STOP_MUSIC_ACTION)
      } else {
        let quizBackgroundMusic = store.state?.presentation?.audioLink?.url
        if (!quizBackgroundMusic) {
          quizBackgroundMusic = playingQuizMusic
        }
        store.dispatch(PLAY_MUSIC_ACTION, quizBackgroundMusic)
      }
    } else {
      // Separate Volume Control OFF (Legacy behavior):
      // - If slide has audio, play slide audio on BGM channel
      // - If slide does not have audio, play default quiz background music
      const quizBackgroundMusic = slideAudioUrl || store.state?.presentation?.audioLink?.url || playingQuizMusic
      store.dispatch(PLAY_MUSIC_ACTION, quizBackgroundMusic)
    }
  },
  'QUIZ/TIMES_UP': (store) => {
    store.dispatch(STOP_MUSIC_ACTION)
  },
  'QUIZ/COUNTDOWN_TO_END_QUESTION': (store) => {
    store.dispatch(PLAY_SOUND_EFFECT_ACTION, 'COUNTDOWN_TO_END_QUESTION')
  },
  'QUIZ/CLOCK_TICK': (store) => {
    store.dispatch(PLAY_SOUND_EFFECT_ACTION, 'CLOCK_TICK')
  },
  'QUIZ/REVEAL_ANSWER': (store) => {
    store.dispatch(PLAY_SOUND_EFFECT_ACTION, 'REVEAL_ANSWER')
  },
  // eslint-disable-next-line sonarjs/cognitive-complexity
  'SLIDE/NAVIGATION': (store, action) => {
    store.dispatch('audio/stopAllSoundEffectsAction')
    store.dispatch(PLAY_SOUND_EFFECT_ACTION, 'SLIDE_NAVIGATION')

    const canSeparateVolume = store.getters[CAN_SEPARATE_VOLUME_CONTROL]
    const presentationMusicUrl = store.state?.presentation?.audioLink?.url

    if (canSeparateVolume) {
      const { toSlide } = action.payload
      const nextSlideType = toSlide?.type
      if (nextSlideType === SLIDE_TYPES_MAP.PICK_ANSWER) {
        if (toSlide.quizStatus == QuizStatuses.LOBBY_SCREEN) {
          const lobbyMusic = store.state?.presentation?.audioLink?.url || MUSIC_SOURCES.DEFAULT_QUIZ_LOBBY_MUSIC
          store.dispatch(PLAY_MUSIC_ACTION, lobbyMusic)
        } else {
          store.dispatch(STOP_MUSIC_ACTION)
        }
      } else if (shouldSilencePresentationAudio(toSlide)) {
        store.dispatch(STOP_MUSIC_ACTION)
      } else if (presentationMusicUrl) {
        store.dispatch(PLAY_MUSIC_ACTION, presentationMusicUrl)
      } else {
        store.dispatch(STOP_MUSIC_ACTION)
      }
      return
    }

    const { fromSlide, toSlide } = action.payload
    const nextSlideType = toSlide?.type
    const nextSlideMusicUrl = toSlide?.audioLink?.url
    const previousSlideHasMusic = fromSlide?.audioLink?.url ||
      (fromSlide.type === SLIDE_TYPES_MAP.PICK_ANSWER && fromSlide.quizStatus == QuizStatuses.LOBBY_SCREEN)
    if (
      (previousSlideHasMusic && !nextSlideMusicUrl) ||
      (nextSlideType === SLIDE_TYPES_MAP.PICK_ANSWER && toSlide.quizStatus != QuizStatuses.LOBBY_SCREEN)
    ) {
      store.dispatch(STOP_MUSIC_ACTION)
    }

    if (nextSlideType !== SLIDE_TYPES_MAP.PICK_ANSWER) {
      store.dispatch(PLAY_MUSIC_ACTION, nextSlideMusicUrl || presentationMusicUrl)
    }
  },
  'QUIZ/LEADERBOARD': (store, action) => {
    let leaderboardSfxKey = 'LEADERBOARD_MIDDLE'
    if (action.payload.isEmpty) {
      leaderboardSfxKey = 'LEADERBOARD_EMPTY'
    } else if (action.payload.isFinal) {
      leaderboardSfxKey = 'LEADERBOARD_FINAL'
    }
    store.dispatch(PLAY_SOUND_EFFECT_ACTION, leaderboardSfxKey)
  },
  BUTTON_CLICK: (store, action) => {
    const sfxKey = action.payload || 'BUTTON_CLICK'
    store.dispatch(PLAY_SOUND_EFFECT_ACTION, sfxKey)
  },
  'SPINNER_WHEEL/TICK': (store, action) => {
    const segNumber = action.payload?.segNumber ?? 1
    const idx = (segNumber - 1) % 4
    const key = `SPINNER_TICK_${idx + 1}`
    store.dispatch('audio/playRapidSoundEffectAction', { key, throttleMs: 45 })
  },
  'SPINNER_WHEEL/SHOW_SPINNING_WHEEL': (store) => {
    store.dispatch(PLAY_SOUND_EFFECT_ACTION, 'SPINNER_WHEEL_SHOW')
  },
  'SPINNER_WHEEL/SPINNING_WHEEL_RESULT': (store) => {
    store.dispatch(PLAY_SOUND_EFFECT_ACTION, 'SPINNER_WHEEL_RESULT')
  },
  'SPINNER_WHEEL/DESTROY': (store) => {
    store.dispatch('audio/stopSoundEffectAction', 'SPINNER_WHEEL_RESULT')
  },

}

const audioPlugin = (store) => {
  store.subscribeAction((action) => {
    if (!store.getters[CAN_USE_NEW_SFX_SETTINGS]) return

    const handler = ACTION_HANDLERS[action.type]
    if (handler) {
      handler(store, action)
    }
  })

  // AHA-43274: the stand-down edge, watched on the getter itself rather than hooked at the site
  // that flips it (services/office commits setPptSlideLostFocus). The getter is the condition every
  // audio guard already switches on, so watching it means "audio stops whenever the frame is
  // silenced", whichever of its four terms moved — no second copy of the condition to keep in step.
  //
  // Deliberately OUTSIDE the subscribeAction above and so not gated on the new-SFX flag: the music
  // this stops reaches the speakers through MusicToggle's <audio autoplay>, which has never been
  // conditioned on that flag either. Its own guard (isEnableAutoplay) carries the same stand-down
  // term, and suppressing autoplay while leaving a playing track running is exactly the half-fix
  // this closes.
  //
  // The AHA-47085 kill switch sits in the two ACTIONS, not in the source expression below, so this
  // watcher tracks the pure stand-down verdict. Folding the flag in here would make the watched
  // value change when the FLAG loads rather than when the frame's status does — Unleash resolves
  // asynchronously, so a frame already stood down at load would see a false -> true edge and read
  // it as a stand-down that never happened.
  store.watch(
    (state, getters) => getters.isPptFrameStoodDown,
    (isStoodDown) => {
      // BOTH edges. An earlier cut stopped on the way down and deliberately restored nothing,
      // reasoning that arrival would replay whatever the slide calls for — it does not (see
      // resumeAudioOnPptStandUpAction), so the first stand-down silenced the frame for the whole
      // show. Pause and resume have to be the same watcher, or the pause is a one-way door.
      if (isStoodDown) {
        store.dispatch(STAND_DOWN_STOP_AUDIO_ACTION)
        return
      }
      store.dispatch(STAND_UP_RESUME_AUDIO_ACTION)
    },
  )

  // AHA-47085: the EDIT-view edge, watched separately from the stand-down one above rather than as a
  // combined `stoodDown || notSelected` term. Combining them would make the watcher fire on a
  // transition between the two verdicts (a show starting or ending flips both at once) and dispatch
  // a resume for a frame that is still silenced, so each edge stays with the action that owns it.
  //
  // Same reason as above for living outside subscribeAction: the track this stops arrives through
  // MusicToggle's <audio autoplay>, which no flag has ever gated.
  store.watch(
    (state, getters) => getters.isPptEditSlideNotSelected,
    (isNotSelected) => {
      if (isNotSelected) {
        store.dispatch(EDIT_GATE_STOP_AUDIO_ACTION)
        return
      }
      store.dispatch(EDIT_GATE_RESUME_AUDIO_ACTION)
    },
  )
}

export default {
  namespaced: true,
  state: _state,
  getters: _getters,
  mutations,
  actions,
  plugins: [audioPlugin],
}
